module.exports = __webpack_public_path__ + "img/ic-pdf.9b6f05fd.svg";